define('OutSystems/ClientRuntime/modules/Database/IndexedDB/IndexedDBSerializer',["require", "exports", "tslib", "../../../DataTypes", "../Common/Serializer", "../DBDataType"], function (require, exports, tslib_1, DataTypes_1, Serializer_1, DBDataType_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var IndexedDBSerializer = (function (_super) {
        tslib_1.__extends(IndexedDBSerializer, _super);
        function IndexedDBSerializer() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        IndexedDBSerializer.prototype.serializeBinaryData = function (value, typeInfo) {
            return value.toArrayBuffer() || null;
        };
        IndexedDBSerializer.prototype.deserializeBinaryData = function (value, typeInfo) {
            var blob = value instanceof ArrayBuffer ? new Blob([value]) : value;
            return new DataTypes_1.BinaryData(blob);
        };
        IndexedDBSerializer.prototype.isConversionNeeded = function (from, to) {
            if (this.isConversionNeededBetweenDBDataTypes(from.type, to.type)) {
                return true;
            }
            if (!!from.isEntityReference !== !!to.isEntityReference) {
                return true;
            }
            if (from.length !== undefined) {
                if (from.decimals !== undefined) {
                    return from.length - from.decimals > to.length - to.decimals;
                }
                return from.length > to.length;
            }
            return false;
        };
        IndexedDBSerializer.prototype.isConversionNeededBetweenDBDataTypes = function (from, to) {
            if (from === undefined) {
                return true;
            }
            if (from === to) {
                return false;
            }
            switch (from) {
                case DBDataType_1.default.BOOLEAN:
                    return to !== DBDataType_1.default.INTEGER;
                case DBDataType_1.default.LONGINTEGER:
                    return to !== DBDataType_1.default.TEXT;
                default:
                    return true;
            }
        };
        return IndexedDBSerializer;
    }(Serializer_1.default));
    exports.default = IndexedDBSerializer;
});
//# sourceMappingURL=IndexedDBSerializer.js.map;
